export enum EnumRetiradaStatus {
    PENDENTE = 0,
    CONCLUIDO = 1,
    ERRO = 2,
    PROCESSANDO = 3
}
